import { FormattedMessage, useIntl } from 'react-intl';

type WizardSuccessProps = {
    assignmentHistory: string[];
    canAssign: boolean;
    canViewDetails: boolean;
    onAssign: () => void;
    onCreateAnother: () => void;
    onReturn: () => void;
    onViewDetails: () => void;
};

type ActionBox = {
    description: string;
    disabled?: boolean;
    iconClass: string;
    onClick: () => void;
    title: string;
};

export const WizardSuccess = (props: WizardSuccessProps) => {

    const { assignmentHistory, canAssign, canViewDetails, onAssign, onCreateAnother, onReturn, onViewDetails } = props;

    const { formatMessage } = useIntl();

    const boxes: ActionBox[] = [
        {
            description: formatMessage({ id: 'assign_this_test_to_a_classroom_or_acces.099966fe', defaultMessage: 'Assign this test to a classroom or access code right now. You can also do this later from the Custom Tests list.' }),
            disabled: !canAssign,
            iconClass: 'fa-solid fa-users',
            onClick: onAssign,
            title: formatMessage({ id: 'assign_test.41d30a22', defaultMessage: 'Assign test' })
        },
        {
            description: formatMessage({ id: 'review_the_saved_test_details_questions.e6d7535d', defaultMessage: 'Review the saved test details, questions, settings, and assignments.' }),
            disabled: !canViewDetails,
            iconClass: 'fa-regular fa-eye',
            onClick: onViewDetails,
            title: formatMessage({ id: 'view_test_details.56c356c9', defaultMessage: 'View test details' })
        },
        {
            description: formatMessage({ id: 'go_back_to_your_list_of_saved_custom_tes.8794d000', defaultMessage: 'Go back to your list of saved custom tests' }),
            iconClass: 'fa-solid fa-list',
            onClick: onReturn,
            title: formatMessage({ id: 'return_to_custom_tests.ce8a1e09', defaultMessage: 'Return to custom tests' })
        },
        {
            description: formatMessage({ id: 'start_a_new_custom_test_from_scratch.de76669d', defaultMessage: 'Start a new custom test from scratch' }),
            iconClass: 'fa-solid fa-plus',
            onClick: onCreateAnother,
            title: formatMessage({ id: 'create_another_test.77a1f329', defaultMessage: 'Create another test' })
        }
    ];

    return (
        <div className={'wizard-success d-flex flex-column align-items-center text-center py-5'}>

            <div
                className={'d-flex align-items-center justify-content-center rounded-circle bg-success text-white mb-3'}
                style={{ height: 48, width: 48 }}
            >
                <i className={'fa-solid fa-check'} />
            </div>

            <h4 className={'fw-bold mb-1'}>
                <FormattedMessage defaultMessage="Custom Test Saved" id="custom_test_saved.34544897" />
            </h4>
            {assignmentHistory.length === 0 ?
                (
                    <p className={'text-muted mb-4'}>
                        <FormattedMessage defaultMessage="Your test has been saved and is ready to assign" id="your_test_has_been_saved_and_is_ready_to.4566efc3" />
                    </p>
                )
                :
                (
                    <div className={'d-flex flex-column gap-1 mb-4'}>
                        {assignmentHistory.map((target, key) => (
                            <p className={'text-success mb-0'} key={key}>
                                <i className={'fa-solid fa-circle-check me-2'} />
                                <FormattedMessage defaultMessage="Your test has been assigned to {target}" id="your_test_has_been_assigned_to_target.2288c15b" values={{ target }} />
                            </p>
                        ))}
                    </div>
                )}

            <div className={'row g-3 w-100'} style={{ maxWidth: 720 }}>
                {boxes.map((box, key) => (
                    <div className={'col-12 col-md-6'} key={key}>
                        <button
                            className={'btn border rounded p-3 text-start w-100 h-100 d-flex flex-column gap-1'}
                            disabled={box.disabled}
                            onClick={box.onClick}
                            type={'button'}
                        >
                            <span className={'fw-semibold d-inline-flex align-items-center gap-2'}>
                                <i className={box.iconClass} />
                                {box.title}
                            </span>
                            <span className={'small text-muted'}>
                                {box.description}
                            </span>
                        </button>
                    </div>
                ))}
            </div>

        </div>
    );

};
